var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { BASE_BORDER_WIDTH, SPACING_S, SPACING_XL } from "../../helpers";
export var AppBarSeparator = styled.div.attrs({
    'data-selector-id': 'appbar-separator'
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n    margin: ", " 0;\n    background-color: silver;\n    opacity: 0.5;\n"], ["\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n    margin: ", " 0;\n    background-color: silver;\n    opacity: 0.5;\n"])), BASE_BORDER_WIDTH, SPACING_XL, SPACING_S);
var templateObject_1;
//# sourceMappingURL=AppBarSeparator.js.map